import ChipedPaymentStatus from "./ChipedPaymentStatus/ChipedPaymentStatus";
import BasePaymentStatus from "./BasePaymentStatus/BasePaymentStatus";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export type Invoice = {
  rectificative_type?: string,
  paid?: string,
  amount_pending?: number,
  amount_total?: number,
  invoice_id: number,
  pending_state_history: Array<{
    change_date: string,
    pending_state: {
      weight?: number,
      ov_description?: string,
    },
  }>
  invoice_fractions?: {
    pending_fractions: number,
    paid_fractions: number,
    fraction_number: number,
    fraction_amount: number,
    paid_amount: number,
    unpaid_amount: number,
  }
}

interface IPaymentStatusProps {
  invoice: Invoice
}

const PaymentStatus = ({
  invoice
}: IPaymentStatusProps) => {
  const Settings = useSettingsContext();
  let paidStatus = null;
  
  switch (Settings?.invoices?.paymentStatus) {
    case "Base":
      paidStatus = <BasePaymentStatus invoice={invoice} />;
      break;
    case "Chiped":
      paidStatus = <ChipedPaymentStatus invoice={invoice} />;
      break;
    default:
      paidStatus = null;
      break;
  }

  return paidStatus;
}

export default PaymentStatus;
